export const FeatureCard = ({ icon: Icon, title, description }) => {
  return (
    <div 
      className="rounded-lg p-6 md:p-8 transition-all duration-200 hover:shadow-md"
      style={{ 
        backgroundColor: '#ffffff', 
        border: '1px solid #e5e5e5',
      }}
      data-testid={`feature-card-${title.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <div 
        className="w-11 h-11 md:w-12 md:h-12 rounded-md flex items-center justify-center mb-4 md:mb-6"
        style={{ backgroundColor: '#eeeeee' }}
      >
        <Icon className="w-5 h-5" style={{ color: '#1c8a56' }} strokeWidth={2} />
      </div>
      <h3 
        className="mb-2 md:mb-3"
        style={{ 
          fontFamily: 'Outfit, sans-serif',
          fontSize: '18px',
          fontWeight: 600,
          color: '#262626',
          letterSpacing: '0em',
          lineHeight: '1.3'
        }}
      >
        {title}
      </h3>
      <p 
        style={{ 
          color: '#6b6b6b',
          fontSize: '15px',
          lineHeight: '1.6',
          letterSpacing: '0.025em'
        }}
      >
        {description}
      </p>
    </div>
  );
};
